import { render, staticRenderFns } from "./TimestampedRTE.vue?vue&type=template&id=1572d6cf&scoped=true"
import script from "./TimestampedRTE.vue?vue&type=script&lang=js"
export * from "./TimestampedRTE.vue?vue&type=script&lang=js"
import style0 from "./TimestampedRTE.vue?vue&type=style&index=0&id=1572d6cf&prod&lang=scss&scoped=true"
import style1 from "./TimestampedRTE.vue?vue&type=style&index=1&id=1572d6cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1572d6cf",
  null
  
)

export default component.exports